// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__hPHK_","goBack":"page_goBack__mt7g2","header":"page_header__KYKQN","tips":"page_tips__EFApw"};